export default {
  // list
  'crm_customer.query.customerCode': '客户编码',
  'crm_customer.query.customerCode.placeholder': '请输入客户编码',
  'crm_customer.query.customerName': '全称',
  'crm_customer.query.customerName.placeholder': '请输入全称',
  'crm_customer.query.customerShortName': '简称',
  'crm_customer.query.customerShortName.placeholder': '请输入简称',
  'crm_customer.query.customerMnemonicCode': '助记码',
  'crm_customer.query.customerMnemonicCode.placeholder': '请输入助记码',
  'crm_customer.query.customerType': '客户类型',
  'crm_customer.query.customerType.placeholder': '请输入客户类型',
  'crm_customer.column.customerCode': '客户编码',
  'crm_customer.column.customerName': '全称',
  'crm_customer.column.customerShortName': '简称',
  'crm_customer.column.tags': '标签',
  'crm_customer.column.customerMnemonicCode': '助记码',
  'crm_customer.column.customerType': '客户类型',
  'crm_customer.column.phone': '电话',
  'crm_customer.column.contactAddress': '联系地址',
  'crm_customer.column.taxpayerId': '纳税人识别号',
  'crm_customer.column.invoiceTitle': '开票抬头',
  'crm_customer.column.invoicePhone': '开票电话',
  'crm_customer.column.invoiceAddress': '开票地址',
  'crm_customer.column.bankName': '开户银行',
  'crm_customer.column.bankAccount': '银行账号',
  'crm_customer.column.enableFlag': '是否启用',
  'crm_customer.column.ourType': '本方公司类型',
  'crm_customer.column.createBy': '创建人',
  'crm_customer.column.updateBy': '更新人',
  'crm_customer.column.createTime': '创建时间',
  'crm_customer.column.updateTime': '更新时间',
  'crm_customer.column.dataSource': '数据来源',
  'crm_customer.column.remark': '备注',
  'crm_customer.column.status': '状态',
  // edit
  'crm_customer.edit.title': '编辑客户',
  'crm_customer.edit.excel': '解析Excel模版',
  'crm_customer.add.title': '新增客户',
  'crm_customer.edit.success': '编辑成功',
  'crm_customer.add.success': '新增成功',
  'crm_customer.form.customerName.required': '全称不能为空',
  'crm_customer.form.customerShortName.required': '简称不能为空',
  'crm_customer.form.customerType.required': '客户类型不能为空',
  'crm_customer.form.enableFlag.required': '是否启用不能为空',
  'crm_customer.form.customerName': '全称',
  'crm_customer.form.customerName.placeholder': '请输入全称',
  'crm_customer.form.customerShortName': '简称',
  'crm_customer.form.customerShortName.placeholder': '请输入简称',
  'crm_customer.form.customerType': '客户类型',
  'crm_customer.form.customerType.placeholder': '请输入客户类型',
  'crm_customer.form.phone': '电话',
  'crm_customer.form.phone.placeholder': '请输入电话',
  'crm_customer.form.contactAddress': '联系地址',
  'crm_customer.form.contactAddress.placeholder': '请输入联系地址',
  'crm_customer.form.taxpayerId': '纳税人识别号',
  'crm_customer.form.taxpayerId.placeholder': '请输入纳税人识别号',
  'crm_customer.form.invoiceTitle': '开票抬头',
  'crm_customer.form.invoiceTitle.placeholder': '请输入开票抬头',
  'crm_customer.form.invoicePhone': '开票电话',
  'crm_customer.form.invoicePhone.placeholder': '请输入开票电话',
  'crm_customer.form.invoiceAddress': '开票地址',
  'crm_customer.form.invoiceAddress.placeholder': '请输入开票地址',
  'crm_customer.form.bankName': '开户银行',
  'crm_customer.form.bankName.placeholder': '请输入开户银行',
  'crm_customer.form.bankAccount': '银行账号',
  'crm_customer.form.bankAccount.placeholder': '请输入银行账号',
  'crm_customer.form.enableFlag': '是否启用',
  'crm_customer.form.enableFlag.placeholder': '请输入是否启用',
  'crm_customer.form.ourType': '本方公司类型',
  'crm_customer.form.ourType.placeholder': '请输入本方公司类型',
}
